import { browserTracingIntegration as browserTracingIntegration$1, WINDOW } from '@sentry/browser';
import { debug, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE } from '@sentry/core';
import { DEBUG_BUILD } from '../debug-build.js';

/**
 * Returns the value of a meta-tag
 */
function getMetaContent(metaName) {
  const optionalDocument = WINDOW.document ;
  const metaTag = optionalDocument?.querySelector(`meta[name=${metaName}]`);
  return metaTag?.getAttribute('content') || undefined;
}

/**
 * A custom browser tracing integrations for Astro.
 */
function browserTracingIntegration(
  options = {},
) {
  const integration = browserTracingIntegration$1(options);

  return {
    ...integration,
    setup(client) {
      // Original integration setup call
      integration.setup?.(client);

      client.on('afterStartPageLoadSpan', pageLoadSpan => {
        const routeNameFromMetaTags = getMetaContent('sentry-route-name');

        if (routeNameFromMetaTags) {
          let decodedRouteName;
          try {
            decodedRouteName = decodeURIComponent(routeNameFromMetaTags);
          } catch {
            // We ignore errors here, e.g. if the value cannot be URL decoded.
            return;
          }

          DEBUG_BUILD && debug.log(`[Tracing] Using route name from Sentry HTML meta-tag: ${decodedRouteName}`);

          pageLoadSpan.updateName(decodedRouteName);
          pageLoadSpan.setAttributes({
            [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'route' ,
            [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.pageload.astro',
          });
        }
      });
    },
  };
}

export { browserTracingIntegration };
//# sourceMappingURL=browserTracingIntegration.js.map
